import {InfoPage, RsnButton} from '@raison/ui-kit';
import React from 'react';
import {Link} from 'react-router';

export type UploadSuccessScreenProps = {
    title?: string;
    message?: string;
};

export function UploadSuccessScreen({
    title = 'Documents sent',
    message = "We will review your documents as soon as possible. Don't worry, it usually takes no more than 3 business days.",
}: UploadSuccessScreenProps) {
    return (
        <InfoPage.Layout symbol={'success'}>
            {{
                center: <InfoPage.Center heading={title} details={message} />,
                footer: (
                    <RsnButton.Alike intent={'primary'} as={Link} to={'/assets'}>
                        Go to my accounts
                    </RsnButton.Alike>
                ),
            }}
        </InfoPage.Layout>
    );
}
